<template>
  <FormContainer>
    <template #title>Représentant légal (à renseigner si l’apprenti est mineur non émancipé)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_52"
          v-model="mineurEmancipeModel"
          label="Mineur émancipé"
          :required="meta.representantLegal?.mineurEmancipe?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.mineurEmancipe?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          help="Indiquer NON si l'apprenti est mineur non émancipé à la date de signature du contrat."
          :disabled="mineurDisabled"
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperToggleSwitch
          id="field_53"
          v-model="representantLegalStructureModel"
          label="Le représentant légal est-il une structure ?"
          :required="meta.representantLegal?.estStructure?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.estStructure?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          :disabled="representantLegalDisabled"
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_54"
          v-model="nomNaissanceRepresentantModel"
          label="Nom de naissance / dénomination"
          :required="meta.representantLegal?.representant?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.representant?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :maxlength="50"
          deletable
          :readonly
          :disabled="representantLegalDisabled"
        />
        <WrapperInput
          id="field_55"
          v-model="prenomRepresentantModel"
          label="Prénom"
          :required="meta.representantLegal?.representant?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.representant?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
          :disabled="representantLegalDisabled"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { CAPP_ACTIONS } from '@/features/interface/demande/capp/useDemandeCAPPActions'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { FormContainer, PLACEHOLDER_NOM, PLACEHOLDER_PRENOM } from '@/features/interface/demande/shared'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const { representantLegalDisabled, mineurDisabled } = inject(CAPP_ACTIONS)!

  const representantLegalStructureModel = setupFieldWithKey<boolean>('representantLegal.estStructure', false)
  const mineurEmancipeModel = setupFieldWithKey<boolean>('representantLegal.mineurEmancipe', false)
  const nomNaissanceRepresentantModel = setupFieldWithKey<string>('representantLegal.representant.nom', true)
  const prenomRepresentantModel = setupFieldWithKey<string>('representantLegal.representant.prenom', true)
</script>
